import { createAction, props } from '@ngrx/store';
export const incrementCurrentWizardStep = createAction('[Custom PDF Report Modal] Increment current wizard step');
export const decrementCurrentWizardStep = createAction('[Custom PDF Report Modal] Decrement current wizard step');
export const setCurrentWizardStep = createAction('[Custom PDF Report Modal] Set current wizard step', props());
